import useSWR from 'swr';
import client from '../js/utils/client';

const fetcher = (...args) => client.get(...args).then(res => res.data);

function useCustomization(productID) {
  const { data, error } = useSWR(
    productID ? `/customizations/get/${productID}/` : null,
    fetcher,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  );

  return {
    data,
    isLoading: !error && !data,
    isError: error
  };
}

export default useCustomization;
